<template>
  <div>
    <v-container fluid>
      <date-filter
        v-model="selectedDate"
        @changeDate="onDateChanged"
        :showTime="true"
        :default-filter="'last_7_days'"
      ></date-filter>
    </v-container>
    <div>
      <v-container fluid>
        <div>
          <h5>สถานที่ซื้อที่มีการสะสมคะแนนเยอะสุด</h5>
        </div>
        <div>
          <div v-for="(item, k) in data" :key="k">
            <v-layout row wrap>
              <v-flex xs3 lg1>
                <v-avatar>
                  <v-img :src="item.profile_pic"></v-img>
                </v-avatar>
              </v-flex>
              <v-flex xs9 lg9>
                <div>
                  {{ item.place }}
                  <span style="float: right; color: grey; font-weight: 600">{{
                    item.quantity | numberFormat
                  }}</span>
                </div>
                <v-progress-linear
                  style="border-radius: 5px; margin-top: 0"
                  color="primary"
                  height="15"
                  :value="getPercent(parseFloat(item.quantity))"
                ></v-progress-linear>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import DateFilter from '../../DateFilter.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  components: {
    DateFilter
  },
  data() {
    return {
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm'),
        end: moment().format('YYYY-MM-DD HH:mm')
      },
      data: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      var data = {
        pageid: this.selectedBot.pageid,
        datefrom: this.selectedDate.start,
        dateto: this.selectedDate.end
      }
      api.getsahapantoplocations(data, (err, response) => {
        if (response.responsecode == 200) {
          this.data = response.data
        }
      })
    },
    getPercent(quantity) {
      var total = 0

      this.data.map((el) => (total += parseFloat(el.quantity)))
      return (parseFloat(quantity) / total) * 100
    },
    onDateChanged() {
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/sahapan/SahapanTopLocation.vue